<template>
  <div :class="{ minimized: isMinimized }" class="nav-sidebar">
    <div class="nav-sidebar-inner-scroll">
      <ul class="nav-sidebar-items">
        <!-- <li>
          <a href="#">
            <span class="icon"><font-awesome-icon icon="th-large" /></span>
            <span>ภาพรวม</span>
          </a>
        </li> -->

        <li :class="{ active: $route.name.match('projects.*') }">
          <router-link :to="{ name: 'projects.index' }" active-class="active">
            <span class="icon"><font-awesome-icon icon="folder" /></span>
            <span>โครงการ</span>
          </router-link>
        </li>
        <li :class="{ active: $route.name.match('budget.*') }">
          <router-link :to="{ name: 'budget.index' }" active-class="active">
            <span class="icon"><font-awesome-icon icon="history" /></span>
            <span>สรุปการใช้จ่ายงบประมาณ</span>
          </router-link>
        </li>
        <!-- <ul class="child-items">
            <li><a href="#"><span>รอการพิจารณา</span></a></li>
            <li><a href="#"><span>รอออกเช็ค</span></a></li>
            <li><a href="#"><span>แยกตามหน่วยงาน</span></a></li>
            <li><a href="#"><span>ทั้งหมด</span></a></li>
          </ul> -->
        <!-- </li> -->
        <div v-if="$auth.check('osda')">
          <li :class="{ active: $route.name.match('checking.*') }">
            <router-link :to="{ name: 'checking.index' }" active-class="active">
              <span class="icon"><font-awesome-icon icon="money-bill-wave" /></span>
              <span>ระบบเช็ค</span>
            </router-link>
          </li>

          <li :class="{ active: $route.name.match('settings*') }">
            <router-link
              :to="{ name: 'settings.users.osda.index' }"
              active-class="active"
            >
              <span class="icon"><font-awesome-icon icon="cog" /></span>
              <span>การตั้งค่า</span>
            </router-link>
            <ul class="child-items">
              <li>
                <router-link
                  :to="{ name: 'settings.users.osda.index' }"
                  active-class="active"
                >
                  <span>บัญชีเจ้าหน้าที่</span>
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{ name: 'settings.faculties.index' }"
                  active-class="active"
                >
                  <span>คณะ</span>
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{ name: 'settings.groups.index' }"
                  active-class="active"
                >
                  <span>หน่วยงาน</span>
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{ name: 'settings.ac-years.index' }"
                  active-class="active"
                >
                  <span>ปีการศึกษา/งบประมาณ</span>
                </router-link>
              </li>
            </ul>
          </li>

          <li class="minimize-button">
            <a href="#" @click="toggleNavbar">
              <span class="icon"><font-awesome-icon :icon="minimizeCaretIcon" /></span>
              <span>ซ่อนเมนู</span>
            </a>
          </li>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isMinimized () {
      return this.$store.state.layout.isSidebarMinimized
    },
    minimizeCaretIcon () {
      return this.isMinimized ? 'angle-double-right' : 'angle-double-left'
    }
  },
  methods: {
    toggleNavbar () {
      this.$store.commit('setIsSidebarMinimized', !this.isMinimized)
    }
  }
}
</script>

<style lang="scss" scoped>
$background-color: #fafafa;
$border-color: #e5e5e5;
$active-color: $brand-color;

.nav-sidebar {
  position: fixed;
  left: 0;
  top: 46px;
  bottom: 0;
  width: 220px;
  background-color: $background-color;
  border-right: 1px solid $border-color;

  &.minimized {
    width: 45px;

    span:not(.icon),
    ul.nav-sidebar-items li ul.child-items {
      display: none;
    }
  }
}

.nav-sidebar-inner-scroll {
  height: 100%;
  width: 100%;
  overflow: auto;
}

ul.nav-sidebar-items {
  list-style: none;
  padding: 0;
  margin: 0;
  height: 100%;

  li {
    a {
      display: block;
      width: 100%;
      padding: 9px 10px;
      color: $gray-600;

      &:hover {
        text-decoration: none;
        color: $gray-800;
        background-color: rgba(0, 0, 0, 0.04);
      }

      .icon {
        font-size: 0.8rem;
        top: -2px;
        position: relative;
        width: 30px;
        display: inline-block;
        text-align: center;
      }
    }

    &.active {
      box-shadow: inset 4px 0 0 $active-color;
      background-color: rgba(0, 0, 0, 0.04);

      ul.child-items {
        display: block;
      }

      & > a {
        color: $active-color;
        font-weight: 500;
      }
    }

    ul.child-items {
      list-style: none;
      margin: 0;
      padding: 0;
      display: none;

      li {
        a {
          padding: 3px 0 3px 40px;

          &.active {
            color: $active-color;
            background-color: rgba(0, 0, 0, 0.05);
          }
        }
      }
    }
  }
}

.minimize-button {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid $border-color;
}
</style>
